import { SERVICES_SELECT } from './index';
import { Action } from '../action';
import { ServiceInfoWithGroup } from '@shared/core';

export class ServicesSelectInitAction implements Action {
	readonly type = SERVICES_SELECT.INIT;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ServicesSelectDestroyAction implements Action {
	readonly type = SERVICES_SELECT.DESTROY;
	constructor(
		public payload?: null,
		public correlationId?: number
	) {}
}

export class ServicesSelectClickServiceAction implements Action {
	readonly type = SERVICES_SELECT.CLICK_SERVICE;
	constructor(
		public payload: ServiceInfoWithGroup,
		public correlationId?: number
	) {}
}
